import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  reviewDateContainer: {
    paddingTop: '.5em',
    width: '50%',
    display: 'inline-block'
  },
  reviewCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #DBE3EF',
    boxShadow: '0px 2px 4px rgba(64, 64, 64, 0.1)',
    borderRadius: '8px',
    padding: '1em',
    height: '100%',
    position: 'relative'
  },
  dateContainer: {
    textAlign: 'right'
  },
  dateLabel: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#BDBDBD'
  },
  reviewBody: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#2F2F4E',
    //display: '-webkit-box',
    wordWrap: 'break-word',
    //overflow: 'hidden',
    //height: '50px',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  },
  nameLabel: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#828282',
    paddingTop: '.5em',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    fontWeight: '600'
  },
  nameContainer: {
  },
  reviewCardSetHeight: {
    height: "100%",
    backgroundColor: "#FFFFFF",
    border: "1px solid #DBE3EF",
    boxShadow: "0px 2px 4px rgba(64, 64, 64, 0.1)",
    borderRadius: "8px",
    padding: "1em",
    // position: "relative",
  },
  reviewBodyOpen: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#2F2F4E",
    // whiteSpace: 'no-wrap',
    // paddingBottom: '2.3em',
    // display: '-webkit-box',
    // wordWrap: 'break-word',
    // overflow: 'hidden',
    // height: '72px',
    // textOverflow: 'ellipsis',
    // WebkitLineClamp: 3,
    // WebkitBoxOrient: 'vertical',
    width: "100%",
  },
  titleLabelOpen: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#262641",
    // whiteSpace: 'no-wrap',
    // display: '-webkit-box',
    // wordWrap: 'break-word',
    // overflow: 'hidden',
    // minHeight: "48px",
    // textOverflow: 'ellipsis',
    // WebkitLineClamp: 2,
    // WebkitBoxOrient: 'vertical',
    width: "100%",
    marginBottom: "8px ",
  },
  readButton: {
    cursor: "pointer",
    color: "#0070EA",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0px",
  },
  commentContainer: {
    marginBottom: '1.5em'
  }
}));

export default function CommentCard(props) {
  const { comment } = props;
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);

  const ref = useRef(null);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    setHeight(ref.current.clientHeight);
    setScrollHeight(ref.current.scrollHeight);
  });

  return (
    <Grid item xs={12} className={classes.commentContainer}>
      <div container className={
          classes.reviewCardSetHeight
      }>
        <Grid item xs={12}>
          <Typography variant='body2' className={classes.reviewBody}
            ref={ref}>{comment.Comment}</Typography>
        </Grid>
        <Grid item xs={12} >
          <Grid container>
            <Grid item xs={6} className={classes.nameContainer}>
              <Typography variant='body2' className={classes.nameLabel}>{comment.ReaderFirstName}</Typography>
            </Grid>
            <div item xs={6} alignItems='flex-end' className={`${classes.dateContainer} ${classes.reviewDateContainer}`}>
              <Typography variant="body2" className={classes.dateLabel}>{comment.DateCommented}</Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
}
